import ImageMissingWeb from "./Icons/ImageMissingWeb";
import LowProductScoreWeb from "./Icons/LowProductScoreWeb"; 
import PriceMissing from "./Icons/PriceMissing";
import DescriptionMissingWeb from "./Icons/DescriptionMissingWeb";
import RejectedProductWeb from "./Icons/RejectedProductWeb";
import RejectedProductMobile from "./Icons/RejectedProductMobile";
import OutDated from "./Icons/OutDated";
import SpecificationMissingWeb from "./Icons/SpecificationMissingWeb";
import CategoryMissing from "./Icons/CategoryMissing";
import CatalogueSupport from "./Icons/CatalogueSupport";
import {updtLbl} from "../../utills";

export const getNotificationCards = (notificationData,{profileTypePlural,profileTypeSingular},user) => {
    const {
        addPriceMissingCount,
        addPriceMissingCountLbl='Product',
        imgMissingCount,
        imgMissingCountLbl='Product',
        specMissingCount,
        specMissingCountLbl='Product',
        descMissingCount,
        descMissingCountLbl='Product',
        rejectedCount,
        rejectedCountLbl='Product',   
        scoreLessThanHundred,
        scoreLessThanHundredLbl='Product',
        smartPriceMissingCount,
        smartPriceMissingCountLbl='Product',
        nonexistingjdmartidcount,
        nonexistingjdmartidcountLbl='Product'
    }  = notificationData;
    let cardData = [];
    if (user){
        if(scoreLessThanHundred && user != 'OWNER') {
            const lbl = updtLbl(scoreLessThanHundred, scoreLessThanHundredLbl);
            const btnLbl = scoreLessThanHundredLbl=='Product / Service' ? 'Product' : scoreLessThanHundredLbl;
            cardData.push({
                label: 'scoreLessThanHundred',
                title: `${scoreLessThanHundred > 99 ? '99+' : scoreLessThanHundred} ${lbl} with Low ${lbl} Score`,
                btnTxt: `Update ${btnLbl}${scoreLessThanHundred > 1 ? 's': ''}`,
                hint: 'Increase product score to get more relevant leads',
                Icon: LowProductScoreWeb,
                prflLbl: lbl
            })
        }
    }
    if(addPriceMissingCount) {
        cardData.push({
            label: 'priceMissingCount',
            title: `${addPriceMissingCount > 99 ? '99+' : addPriceMissingCount} ${updtLbl(addPriceMissingCount, addPriceMissingCountLbl)} without Price`,
            btnTxt: 'Add Price',
            hint: 'Add price to get more customers',
            Icon:   PriceMissing,
            prflLbl: ''
        })
    }
    if(imgMissingCount && user == 'OWNER') {
        const lbl = updtLbl(imgMissingCount, imgMissingCountLbl);
        const btnLbl = imgMissingCountLbl=='Product / Service' ? 'Product' : imgMissingCountLbl;
        cardData.push({
            label: 'imgMissingCoun',
            title: `${imgMissingCount > 99 ? '99+' : imgMissingCount} ${lbl} without Images`,
            btnTxt: `Add ${btnLbl} Image${imgMissingCount > 1 ? 's': ''}`,
            hint: 'Help your customers find what they want',
            Icon: ImageMissingWeb,
            prflLbl: lbl
        })
    }
    if(specMissingCount) {
        cardData.push({
            label: 'specMissingCount',
            title: `${specMissingCount > 99 ? '99+' : specMissingCount} ${updtLbl(specMissingCount, specMissingCountLbl)} without Specifications`,
            btnTxt: `Add Specifications`,
            hint: 'Help your customers find what they want',
            Icon: SpecificationMissingWeb,
            prflLbl: ''
        })
    }
    if(descMissingCount) {
        cardData.push({
            label: 'descMissingCount',
            title: `${descMissingCount > 99 ? '99+' : descMissingCount} ${updtLbl(descMissingCount, descMissingCountLbl)} without Description`,
            btnTxt: `Add Description`,
            hint: 'Help your customers find what they want',
            Icon: DescriptionMissingWeb,
            prflLbl: ''
        })
    }
    if(rejectedCount) {
        const lbl = updtLbl(rejectedCount, rejectedCountLbl);
        const btnLbl = rejectedCountLbl=='Product / Service' ? 'Product' : rejectedCountLbl;
        cardData.push({
            label: 'rejectedCount',
            title: `${rejectedCount > 99 ? '99+' : rejectedCount} Rejected ${lbl}`,
            btnTxt: `Update ${btnLbl}${rejectedCount > 1 ? 's': ''}`,
            hint: `Update ${lbl} to display them online`,
            Icon: RejectedProductWeb,
            prflLbl: lbl
        })
    }
    if(smartPriceMissingCount && user == 'OWNER') {
        cardData.push({
            label: 'smartPriceMissingCount',
            title: `Outdated Price in ${smartPriceMissingCount > 99 ? '99+': smartPriceMissingCount} ${updtLbl(smartPriceMissingCount, smartPriceMissingCountLbl)}`,
            btnTxt: 'Update Price',
            hint: 'Show latest price to your customers',
            Icon: OutDated,
            prflLbl: ''
        })
    }
    if(nonexistingjdmartidcount && user == 'OWNER') {
        cardData.push({
            label: 'nonexistingjdmartidcount',
            title: `${nonexistingjdmartidcount > 99 ? '99+': nonexistingjdmartidcount} Categor${nonexistingjdmartidcount>1 ? 'ies' : 'y'} without ${updtLbl(nonexistingjdmartidcount, nonexistingjdmartidcountLbl)}`,
            btnTxt: `Add ${nonexistingjdmartidcountLbl}`,
            hint: 'Add more products to reach more customers',
            Icon: CategoryMissing,
            prflLbl: ''
        })
    }
    const showSupportHelp = (addPriceMissingCount || imgMissingCount || specMissingCount || descMissingCount || rejectedCount || smartPriceMissingCount || nonexistingjdmartidcount);
    if(user == 'OWNER' && showSupportHelp) {
        cardData.push({
            label: 'catalogSupport',
            title: 'Need Help?',
            hint: 'Click the button below to view support options',
            btnTxt: 'Get Support',
            Icon: CatalogueSupport,
            prflLbl: ''
        })
    }

    return cardData;
}

export const debounceFunc = (func, delay) => {
    let timeoutId;
    return function (...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            func(...args);
        }, delay);
    };
}

export const openInIframe = (path = '',callBackFn = null) => {
    if(path) {
        // var loader = document.querySelector('#loader-container');
        // loader.style.position = 'absolute';
        // loader.style.zIndex = '1040';
        var iframeWrapper = document.createElement('div');
        iframeWrapper.setAttribute("id","omniIframe");
        iframeWrapper.style.cssText="visibility:hidden;position:fixed;top:0;height:100vh;display:flex;align-items:center;justify-content:end;width:100%;z-index:99999;"
        var iframeToReport = document.createElement("iframe");
        iframeToReport.style.cssText= "width: 100%;height:100%;border:none;transition:width 0.2s";
        window.callback = {fn: callBackFn};
        // let params = '&closeIframe=1';
        // if(param && Object.keys(param).length) {
		// 	for(const key in param) {
		// 		params += `&${key}=${param[key]}`;
		// 	}
		// }
		// params += '&isDev=1'
        // params = encodeURIComponent(params)
        iframeToReport.src = `http://${window.location.host}/${path}?closeIframe=1`;
        iframeWrapper.appendChild(iframeToReport);
        document.body.appendChild(iframeWrapper);
        // iframecontentWindow = iframeToReport.contentWindow || iframeToReport.contentDocument;
    }
}
